import { Grid, Paper, Typography } from '@mui/material'
import React, { useMemo } from 'react'
import NoDataAvailableCard from './NoDataAvailableCard'
import GraphCard from './GraphCard'
import CardSkeleton from './CardSkeleton'
import CardFilter from './CardFilter'

const CashflowAndForwardBilling = ({ cashflowData, loading = {}, filters = {}, onFilterChange, currencies = [], cardFiltersDisabled = false }) => {
    const waterfallOptions = cashflowData?.cashflow_waterfall?.graph_values?.options
    const waterfallGraphOption = useMemo(() => (
        waterfallOptions ? { ...waterfallOptions, title: undefined } : null
    ), [waterfallOptions])

    const forecastOptions = cashflowData?.cashflow_forecast?.graph_values?.options
    const forecastGraphOption = useMemo(() => (
        forecastOptions ? { ...forecastOptions, title: undefined } : null
    ), [forecastOptions])

    return (
        <div className="contract-analytics-wrapper">
            <div className="ca-page-header">
                <Typography fontSize='15px' fontFamily="Roboto-SemiBold !important">Cashflow & Forward Billing </Typography>
            </div>
            <Grid container spacing={1.5} mx={1} sx={{ alignItems: 'stretch' }}>
                <Grid size={{ md: 8, xs: 12 }} sx={{ display: 'flex' }}>
                    <Paper className="ca-equal-card">
                        <CardFilter disabled={cardFiltersDisabled} title="Cashflow Waterfall — Rent, MR, Claims & Other" filter={filters.cashflow_waterfall} onChange={(filter) => onFilterChange('cashflow_waterfall', filter)} currencyOptions={currencies} />
                        {loading.cashflow_waterfall ? (
                            <CardSkeleton />
                        ) : (
                            <div className="ca-graph-container">
                                {!waterfallGraphOption ? (
                                    <NoDataAvailableCard title='No Cashflow data available' subtext='Date filter is required for this graph, try adjusting the date range' />
                                ) : (
                                    <GraphCard option={waterfallGraphOption} height='225px' />
                                )}
                            </div>
                        )}
                    </Paper>
                </Grid>
                <Grid size={{ md: 4, xs: 12 }} sx={{ display: 'flex' }}>
                    <Paper className="ca-equal-card ca-side-card">
                        <CardFilter disabled={cardFiltersDisabled} title="Next 12 Months — Known vs Projected" filter={filters.cashflow_forecast} onChange={(filter) => onFilterChange('cashflow_forecast', filter)} currencyOptions={currencies} />
                        {loading.cashflow_forecast ? (
                            <CardSkeleton />
                        ) : (
                            <div className="ca-graph-container">
                                {!forecastGraphOption ? (
                                    <NoDataAvailableCard title='No data available' subtext='Try adjusting the date range' />
                                ) : (
                                    <GraphCard option={forecastGraphOption} height='225px' />
                                )}
                            </div>
                        )}
                    </Paper>
                </Grid>
            </Grid>
        </div>
    )

}

export default CashflowAndForwardBilling
